import { NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { CommonModule } from '@angular/common';
import { HalfDayBlockComponent } from './halfday-block';

@NgModule({
    declarations: [
        HalfDayBlockComponent,
    ],
    imports: [
        CommonModule,
        IonicModule
    ],
    exports: [
        HalfDayBlockComponent
    ]
})
export class HalfDayBlockComponentModule { }


// WEBPACK FOOTER //
// ./src/components/halfday-block/halfday-block.module.ts